export default function Kiln() {
  return (
    <section id="kiln" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">窯元紹介</h2>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">横山 雄一</h3>
            <p className="text-gray-600 text-xl leading-relaxed mb-6">
              陶芸のふるさと、栃木県益子町の窯元｢益子焼窯元よこやま｣のご紹介です。父（横山由夫）が1971年に築窯し、現在は親子4人と若手スタッフで陶器製造をしております。
            </p>
            <p className="text-gray-600 text-xl leading-relaxed mb-6">
              特徴のひとつは｢炭化焼き｣という焼成方法で、益子の粘土を生かした味わいのある風合いが特徴です。他にもカフェシリーズなど、新しいデザインの益子焼も制作。通販の他、益子の直営店では、手にとってご覧いただけます。
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://tougei.net/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-2 px-5 py-3 bg-amber-50 border border-amber-200 rounded-full text-amber-700 hover:bg-amber-100 hover:border-amber-400 transition-all cursor-pointer text-base font-medium whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-global-line text-base"></i>
                </div>
                tougei.net
              </a>
              <a
                href="https://www.facebook.com/tougeiyokoyama/?ref=embed_page#"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-2 px-5 py-3 bg-amber-50 border border-amber-200 rounded-full text-amber-700 hover:bg-amber-100 hover:border-amber-400 transition-all cursor-pointer text-base font-medium whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-facebook-circle-fill text-base"></i>
                </div>
                Facebook
              </a>
              <a
                href="https://www.instagram.com/yuichiyokoyamatougei/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-2 px-5 py-3 bg-amber-50 border border-amber-200 rounded-full text-amber-700 hover:bg-amber-100 hover:border-amber-400 transition-all cursor-pointer text-base font-medium whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-instagram-line text-base"></i>
                </div>
                Instagram（個人）
              </a>
              <a
                href="https://www.instagram.com/tougeiyokoyama/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-2 px-5 py-3 bg-amber-50 border border-amber-200 rounded-full text-amber-700 hover:bg-amber-100 hover:border-amber-400 transition-all cursor-pointer text-base font-medium whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-instagram-line text-base"></i>
                </div>
                Instagram（窯元）
              </a>
            </div>
          </div>
          
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/f67aadfa9e59208c13c0050e7c573a25.png" 
                alt="窯元 横山雄一" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-amber-500 rounded-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
